<template>
  <span>
    <DaiCapaGeojson
      id="edafologia_histosol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_histosol.geojson'"
      titulo="Histosol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#BAD44B' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_histosol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_phaeozem"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_phaeozem.geojson'"
      titulo="Phaeozem"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#FCDBAC' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_phaeozem']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_andosol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_andosol.geojson'"
      titulo="Andosol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#FA9A87' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_andosol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_gleysol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_gleysol.geojson'"
      titulo="Gleysol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#D62DD3' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_gleysol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_vertisol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_vertisol.geojson'"
      titulo="Vertisol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#8a5a73' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_vertisol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_fluvisol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_fluvisol.geojson'"
      titulo="Fluvisol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#558562' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_fluvisol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_solonchak"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_solonchak.geojson'"
      titulo="Solonchak"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#F9B64E' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_solonchak']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_solonetz"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_solonet.geojson'"
      titulo="Solonetz"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#DB0038' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_solonetz']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_calcisols"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_calcisol.geojson'"
      titulo="Calcisols"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#F87C1B' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_calcisols']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_regosol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_regosol.geojson'"
      titulo="Regosol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#89de8c' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_regosol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_cambisol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_cambisol.geojson'"
      titulo="Cambisol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#b79f7d' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_cambisol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_arenosol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_arenosol.geojson'"
      titulo="Arenosol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#fcff71' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_arenosol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_luvisol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_luvisol.geojson'"
      titulo="Luvisol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#613e8b' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_luvisol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_leptosol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_leptosol.geojson'"
      titulo="Leptosol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#c2b0ef' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_leptosol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_umbrisol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_umbrisol.geojson'"
      titulo="Umbrisol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#d3758f' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_umbrisol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_durisol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_durisol.geojson'"
      titulo="Durisol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#9e3e2c' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_durisol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_planosol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_planosol.geojson'"
      titulo="Planosol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#532a3e' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_planosol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_anthrosols"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_anthrosol.geojson'"
      titulo="Anthrosols"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#278402' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_anthrosols']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_technosol"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_technosol.geojson'"
      titulo="Technosol"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#71836a' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_technosol']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="edafologia_tierras_miscelaneas"
      :url="publicPath+'data/capasv2/08_edafologia_wrb_grupo2_tierras-miscelaneas.geojson'"
      titulo="Tierras misceláneas"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#eaeaea' },
      }"
      tipoGeometria="Polygon"
      :z-index="1"
      :renderizarComoImagen="true"
      :visible.sync="visibles['edafologia_tierras_miscelaneas']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
  </span>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      visibles: {
        edafologia_histosol: false,
        edafologia_phaeozem: false,
        edafologia_andosol: false,
        edafologia_gleysol: false,
        edafologia_vertisol: false,
        edafologia_fluvisol: false,
        edafologia_solonchak: false,
        edafologia_solonetz: false,
        edafologia_calcisols: false,
        edafologia_regosol: false,
        edafologia_cambisol: false,
        edafologia_arenosol: false,
        edafologia_luvisol: false,
        edafologia_leptosol: false,
        edafologia_umbrisol: false,
        edafologia_durisol: false,
        edafologia_planosol: false,
        edafologia_anthrosols: false,
        edafologia_technosol: false,
        edafologia_tierras_miscelaneas: false,
      },
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    ...mapState("mapa", ["temasExpandidos"]),
    esteTemaActivo() {
      return this.temasExpandidos.edafologia;
    },
  },
  watch: {
    esteTemaActivo(nv) {
      this.visibles["edafologia_histosol"] = nv;
      this.visibles["edafologia_phaeozem"] = nv;
      this.visibles["edafologia_andosol"] = nv;
      this.visibles["edafologia_gleysol"] = nv;
      this.visibles["edafologia_vertisol"] = nv;
      this.visibles["edafologia_fluvisol"] = nv;
      this.visibles["edafologia_solonchak"] = nv;
      this.visibles["edafologia_solonetz"] = nv;
      this.visibles["edafologia_calcisols"] = nv;
      this.visibles["edafologia_regosol"] = nv;
      this.visibles["edafologia_cambisol"] = nv;
      this.visibles["edafologia_arenosol"] = nv;
      this.visibles["edafologia_luvisol"] = nv;
      this.visibles["edafologia_leptosol"] = nv;
      this.visibles["edafologia_umbrisol"] = nv;
      this.visibles["edafologia_durisol"] = nv;
      this.visibles["edafologia_planosol"] = nv;
      this.visibles["edafologia_anthrosols"] = nv;
      this.visibles["edafologia_technosol"] = nv;
      this.visibles["edafologia_tierras_miscelaneas"] = nv;
    },
  },
  methods:{
    tooltip(f){
      return `Clasificación WRB: ${f.wrb_grupo2}`
    }
  },
  beforeMount(){
    let nv = this.esteTemaActivo;
    this.visibles["edafologia_histosol"] = nv;
    this.visibles["edafologia_phaeozem"] = nv;
    this.visibles["edafologia_andosol"] = nv;
    this.visibles["edafologia_gleysol"] = nv;
    this.visibles["edafologia_vertisol"] = nv;
    this.visibles["edafologia_fluvisol"] = nv;
    this.visibles["edafologia_solonchak"] = nv;
    this.visibles["edafologia_solonetz"] = nv;
    this.visibles["edafologia_calcisols"] = nv;
    this.visibles["edafologia_regosol"] = nv;
    this.visibles["edafologia_cambisol"] = nv;
    this.visibles["edafologia_arenosol"] = nv;
    this.visibles["edafologia_luvisol"] = nv;
    this.visibles["edafologia_leptosol"] = nv;
    this.visibles["edafologia_umbrisol"] = nv;
    this.visibles["edafologia_durisol"] = nv;
    this.visibles["edafologia_planosol"] = nv;
    this.visibles["edafologia_anthrosols"] = nv;
    this.visibles["edafologia_technosol"] = nv;
    this.visibles["edafologia_tierras_miscelaneas"] = nv;
  }
};
</script>